module.exports = __webpack_public_path__ + "img/pic3.60d9b4db.jpg";